import { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { Navigate } from "react-router-dom";
import { useProfile } from '../Common/Hooks/UserHooks';
import { setAuthorization } from '../helpers/api_helper';
import { logoutUser, loadTags, loadTagRules, loadCompanies, loadPersons, loadCategories, loadProjects, loadProjectTypes, loadAccounts, loadOrgConfig, loadUiPrefs, loadWizardAlerts } from '../slices/thunk';

const AuthProtected = (props) => {
    const dispatch = useDispatch();
    const { userProfile, loading, token } = useProfile();

    useEffect(() => {
      if (userProfile && !loading && token) {
        setAuthorization(token);
        // First: it decides which columns/fields/routes the rest of the app shows.
        dispatch(loadOrgConfig());
        dispatch(loadUiPrefs());
        dispatch(loadTags());
        dispatch(loadTagRules());
        dispatch(loadAccounts());
        dispatch(loadCompanies());
        dispatch(loadPersons());
        dispatch(loadCategories());
        dispatch(loadProjects());
        dispatch(loadProjectTypes());
        dispatch(loadWizardAlerts());

      } else if (!userProfile && loading && !token) {
        dispatch(logoutUser());
      }
    }, [token, userProfile,  loading, dispatch]);

    /*
      Navigate is un-auth access protected routes via url
      */

    if (!userProfile && loading && !token) {
      return (
        <Navigate to={{ pathname: "/login"}} />
      );
    }

    return <>{props.children}</>;
}

export default AuthProtected
